module.exports = __webpack_public_path__ + "img/emoji_99.2676dd91.png";